import React from 'react'

import { SimpleGrid, Text } from '@driftt/dds'
import { KPICard, TypeFormats } from '@driftt/dds.reports'

import { isNilOrEmpty } from 'utils/ramda'

import { useSiteConciergeSearchCardsMertics } from '../Hooks'

import { getFooterInfo } from './KPICards.helpers'

type CardMetrics = {
  searchButtonClicks: number
  searchesPerformed: number
  sourceClickThroughs: number
  totalButtonImpressions: number
}

export const KPICards = () => {
  const {
    metrics: currentMetrics = {},
    isLoading,
    isError,
  } = useSiteConciergeSearchCardsMertics()

  const { metrics: previousMetrics = {} } = useSiteConciergeSearchCardsMertics({
    isPreviousTimePeriod: true,
  })

  const {
    searchButtonClicks: currentSearchButtonClicks,
    searchesPerformed: currentSearchesPerformed,
    sourceClickThroughs: currentSourceClickThroughs,
    totalButtonImpressions: currentTotalButtonImpressions,
  } = currentMetrics as CardMetrics

  const {
    searchButtonClicks: previousSearchButtonClicks,
    searchesPerformed: previousSearchesPerformed,
    sourceClickThroughs: previousSourceClickThroughs,
  } = previousMetrics as CardMetrics

  const showFooterInfo = !isError && !isLoading

  return (
    <SimpleGrid columns={3} gap={3}>
      {[
        {
          metric: currentSearchButtonClicks,
          previousMetric: previousSearchButtonClicks,
          title: 'Intelligent Search button clicks',
          description:
            'How often a site visitor clicked on the Intelligent Search button when it was present',
          footerInfo: getFooterInfo({
            impressions: currentSearchButtonClicks,
            totalImpressions: currentTotalButtonImpressions,
            label: 'total button impressions',
            showFooterInfo,
          }),
        },
        {
          metric: currentSearchesPerformed,
          previousMetric: previousSearchesPerformed,
          title: 'Searches performed',
          description:
            'How often a visitor who opened Intelligent Search performed a search',
          footerInfo: getFooterInfo({
            impressions: currentSearchesPerformed,
            totalImpressions: currentSearchButtonClicks,
            label: 'search impressions',
            showFooterInfo,
          }),
        },
        {
          metric: currentSourceClickThroughs,
          previousMetric: previousSourceClickThroughs,
          title: 'Source click-throughs',
          description:
            'How often a site visitor clicked a source in a search result',
          footerInfo: getFooterInfo({
            impressions: currentSourceClickThroughs,
            totalImpressions: currentSearchesPerformed,
            label: 'results seen',
            showFooterInfo,
          }),
        },
      ].map((card, index) => (
        <KPICard
          key={index}
          formatMetric={(totalConversations) =>
            TypeFormats.RAW_HUMANIZED(totalConversations)
          }
          metric={card.metric}
          previousMetric={card.previousMetric}
          isLoading={isLoading}
          hasNoData={isNilOrEmpty(currentMetrics)}
          hasError={isError}
        >
          <KPICard.Header title={card.title} description={card.description} />
          <KPICard.Metric />
          <Text>{card.footerInfo}</Text>
        </KPICard>
      ))}
    </SimpleGrid>
  )
}
